"use strict";
/* globals module */
/**
 * @module commerceProductRoute
 * @description Baasic Commerce Product Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Product Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var CommerceProductRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductRoute, _super);
    function CommerceProductRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/products/{?searchQuery,page,rpp,sort,embed,fields,productCategoryIds,productCategoryAbrvs}';
        _this.getRoute = 'commerce/products/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/products';
        _this.updateRoute = 'commerce/products/{id}';
        _this.deleteRoute = 'commerce/products/{id}';
        return _this;
    }
    /**
     * Parses find commerce product route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `productCategoryIds` - A list of product category ids.
     * - `productCategoryAbrvs` - A list of product category abbreviations.
     * @method
     * @example commerceProductRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceProductRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceProductRoute.get(id, options);
     **/
    CommerceProductRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceProductRoute.create();
     **/
    CommerceProductRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceProductRoute.update(data);
     **/
    CommerceProductRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce product route; this URI template does not expose any additional options.
    * @method
    * @example commerceProductRoute.delete(data);
    **/
    CommerceProductRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    CommerceProductRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductRoute);
    return CommerceProductRoute;
}(common_1.BaseRoute));
exports.CommerceProductRoute = CommerceProductRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
